<aside
  class="sidebar shrink-0 h-screen overflow-y-scroll no-scrollbar border-none bg-[#1A1C1E]"
>
  <div class="flex flex-col h-full">
    <div class="flex items-center gap-2">
      <img src="/assets/images/logo.png" class="w-[35px] mr-[-6px]" />
      <h1 class="!text-[18px] !text-white !font-semibold whitespace-nowrap">
        {{ "sidebar.title" | translate }}
      </h1>
    </div>
    <div class="flex w-full justify-center mt-8">
      <div
        class="flex items-center px-4 py-[2px]"
        style="
          border: 1px solid #333;
          border-radius: var(--icon-button-border-radius);
        "
      >
        <h3
          class="capitalize text-base !text-[#777] font-semibold whitespace-nowrap pt-[2px] !m-0 !ms-1"
        >
          {{ user.username }}
        </h3>
      </div>
    </div>

    <!-- ========================================== BRANCH ================================================== -->

    <div class="mt-6">
      <p class="!text-[#666666] text-sm text-center font-medium !mb-3">شعبه</p>
      <div class="flex w-full justify-center">
        @if (!userHasBothBranches) {
          <span
            class="bg-[#ffffff18] py-2 px-4 rounded-[12px] text-[12px] font-medium"
          >
            <ng-template [appHasAccess]="[Role.Isfahan]">
              <span>اصفهان</span>
            </ng-template>

            <ng-template [appHasAccess]="[Role.Tehran]">
              <span>تهران</span>
            </ng-template>
          </span>
        } @else {
          <mat-button-toggle-group
            [value]="defaultBranch"
            (change)="onChangeBranch($event)"
            class="w-[150px]"
          >
            <mat-button-toggle value="ISFAHAN">اصفهان</mat-button-toggle>
            <mat-button-toggle value="TEHRAN">تهران</mat-button-toggle>
          </mat-button-toggle-group>
        }
      </div>
    </div>

    <!-- ========================================== MAIN MENU ================================================== -->

    <p class="!text-[#666666] text-sm font-medium !mt-10 !mb-4">
      {{ "sidebar.mainMenu" | translate }}
    </p>
    @for (item of menuItems; track item) {
      <ng-template
        [appHasAccess]="
          userRoles?.includes(Role.EmergencyMode) && !item?.showInEmergencyMode
            ? undefined
            : item.roles
        "
      >
        @if (!isParentNode(item)) {
          <button
            (click)="clickMenuItem($any(item).route)"
            [routerLink]="[$any(item).route]"
            [routerLinkActiveOptions]="{exact: $any(item).exact || false}"
            class="sidebar__button"
            mat-button
            routerLinkActive="sidebar__button--active"
            [appDataTestId]="$any(item).dataTestId"
          >
            <div class="sidebar__button-inner-box flex items-center">
              <mat-icon class="sidebar__button-icon">{{ item.icon }}</mat-icon>
              <span>{{ item.translateKey | translate }}</span>
            </div>
          </button>
        }
        @if (isParentNode(item)) {
          <mat-accordion>
            <mat-expansion-panel
              [expanded]="isAccordionActive(item)"
              [class.sidebar__expansion-panel--active]="
                isParentHeaderActive(item)
              "
            >
              <mat-expansion-panel-header
                [class.sidebar__expansion-header--active]="
                  isParentHeaderActive(item)
                "
              >
                <div
                  class="sidebar__button-inner-box flex items-center !text-white"
                >
                  <mat-icon class="sidebar__button-icon">{{
                    item.icon
                  }}</mat-icon>
                  <span>{{ item.translateKey | translate }}</span>
                </div>
              </mat-expansion-panel-header>
              @for (childItem of $any(item).children; track childItem) {
                <ng-template [appHasAccess]="childItem.roles">
                  @if (!isParentNode(childItem)) {
                    <button
                      (click)="clickMenuItem(childItem.route)"
                      [routerLinkActiveOptions]="{
                        exact: childItem.exact || false,
                      }"
                      class="sidebar__button"
                      mat-button
                      routerLinkActive="sidebar__button--active"
                      [appDataTestId]="childItem.dataTestId"
                    >
                      <div class="sidebar__button-inner-box flex items-center">
                        <span>{{ childItem.translateKey | translate }}</span>
                      </div>
                    </button>
                  }
                </ng-template>
              }
            </mat-expansion-panel>
          </mat-accordion>
        }
      </ng-template>
    }

    <ng-template [appHasAccess]="[Role.CreateEmployee]">
      <a
        class="sidebar__button"
        mat-button
        routerLinkActive="sidebar__button--active"
        [href]="environment.userManagementSystem"
        target="_blank"
      >
        <div class="sidebar__button-inner-box flex items-center">
          <mat-icon class="sidebar__button-icon">manage_accounts</mat-icon>
          <span>{{ "manageUsers" | translate }}</span>
        </div>
      </a>
    </ng-template>

    <!-- ========================================== SETTINGS ================================================== -->

    <ng-template
      [appHasAccess]="[
        Role.UpdateBranchLock,
        Role.EnableEmergencyMode,
        Role.DisableEmergencyMode,
      ]"
    >
      <p class="!text-[#666666] text-sm font-medium !mt-10 !mb-6">
        {{ "sidebar.settings" | translate }}
      </p>
      <div>
        <ng-template [appHasAccess]="[Role.UpdateBranchLock]">
          <!-- close/open market button -->
          <button
            class="sidebar__button sidebar__logout-button w-full justify-center gap-1 text-white !bg-danger pt-2 !mb-2"
            mat-button
            (click)="toggleMarketLock()"
          >
            @if (branchInfo && branchInfo.locked) {
              <mat-icon class="!ml-[-1px] !text-success">lock_open</mat-icon>
            }
            @if (branchInfo && !branchInfo.locked) {
              <mat-icon class="!ml-[-1px] text-white">lock</mat-icon>
            }
            {{
              (branchInfo && branchInfo.locked ? "unlockMarket" : "lockMarket")
                | translate
            }}
          </button>
        </ng-template>

        <!-- enable emergency mode -->
        @if (!branchInfo?.is_emergency) {
          <ng-template [appHasAccess]="[Role.EnableEmergencyMode]">
            <button
              class="sidebar__button sidebar__logout-button w-full justify-center items-center gap-1 text-white !bg-danger pt-2 !mb-0"
              mat-button
              (click)="enableEmergencyMode()"
            >
              <mat-icon class="!ml-[-1px] -mt-1 text-white">gpp_maybe</mat-icon>
              {{ "branch.enableEmergencyMode" | translate }}
            </button>
          </ng-template>
        }

        <!-- disable emergency mode -->
        @if (branchInfo?.is_emergency) {
          <ng-template [appHasAccess]="[Role.DisableEmergencyMode]">
            <button
              class="sidebar__button sidebar__logout-button w-full justify-center items-center gap-1 text-white !bg-danger pt-2 !mb-0"
              (click)="disableEmergencyMode()"
            >
              <mat-icon class="!ml-[-1px] text-white">exit_to_app</mat-icon>
              {{ "branch.disableEmergencyMode" | translate }}
            </button>
          </ng-template>
        }
      </div>
    </ng-template>

    <!--  please DO NOT remove this extra span -->
    <span class="w-full invisible">.</span>
  </div>
</aside>
